import { menuConfig } from './menu'
import { elemToHtmlConfig } from './elem-to-html'
import { renderToElemConfig } from './render-elem'
import { parseHtmlConfig } from './parse-elem-html'
import withPagePad from './plugin'
import { MENU_KEY,ELEMENT_TYPE} from './constants'
 

// 用来注册自定义的方法
export const imgLoadingBlock = {
    menus: [menuConfig],
    renderElems: [renderToElemConfig],
    elemsToHtml: [elemToHtmlConfig],
    parseElemsHtml: [parseHtmlConfig],
    editorPlugin: withPagePad
}

export const IMG_LOADING_BLOCK_MENU_KEY = MENU_KEY
export const IMG_LOADING_BLOCK_TYPE = ELEMENT_TYPE
 